export function stopStream(stream: MediaStream | null | undefined): void {
  stream?.getTracks().forEach((track) => track.stop());
}

/** Camera and QR reader together: a stream that arrives after either one failed is stopped, never left on. */
export async function openCamera<Detector>(
  requestStream: () => Promise<MediaStream>,
  loadDetector: () => Promise<Detector>,
): Promise<[Detector, MediaStream]> {
  const streamRequest = requestStream();
  try {
    return await Promise.all([loadDetector(), streamRequest]);
  } catch (error) {
    streamRequest.then(stopStream, () => undefined);
    throw error;
  }
}
